import * as React from "react";
import PropTypes from "prop-types";
import * as Theme from "../../../app/Theme";
import TSlideDrawer from "../../common/TSlideDrawer";
import HLResultForm from "../Forms/HLResultForm";
import TButton from "../../common/TButton";
// import IconButton from "@material-ui/core/IconButton";
// import GetAppIcon from "@material-ui/icons/GetApp";
// import HLStep2Form from "../Forms/HLStep2Form";

class HLResultSlideDrawer extends React.Component {
    static propTypes = {
        onDrawerChange: PropTypes.func,
        intervAreaObjList: PropTypes.arrayOf(PropTypes.object),
        intervObjList: PropTypes.arrayOf(PropTypes.object),
        rankedIntervMstID2DObjArray: PropTypes.arrayOf(PropTypes.number),
        resultWkbkFileURLString: PropTypes.string,
        showChildrenIntervBool: PropTypes.bool,
        onShowChildrenIntervChange: PropTypes.func,
        showMaternalIntervBool: PropTypes.bool,
        onShowMaternalIntervChange: PropTypes.func,
    };

    static defaultProps = {
        onDrawerChange: () => console.log("onDrawerChange"),
        intervAreaObjList: [],
        intervObjList: [],
        rankedIntervMstID2DObjArray: [],
        resultWkbkFileURLString: "",
        showChildrenIntervBool: true,
        onShowChildrenIntervChange: () => console.log("onShowChildrenIntervChange"),
        showMaternalIntervBool: true,
        onShowMaternalIntervChange: () => console.log("onShowMaternalIntervChange"),
    };

    // markRef
    state = {
        tableRef: null,
    };

    // markRef
    onDownloadBtnClick = () => {
        /* Props */
        const props = this.props;
        const resultWkbkFileURLString = props.resultWkbkFileURLString;

        if (resultWkbkFileURLString !== "") {
            console.log(window.API_URL_BASE + "/" + resultWkbkFileURLString);
            let a = document.createElement("a");
            a.href = window.API_URL_BASE + "/" + resultWkbkFileURLString;
            a.download = "Prioritized interventions.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
        //this.state.tableRef.current.exportToExcel("RankedInterventions.xlsx");
    };

    render() {
        const props = this.props;
        const onDrawerChange = props.onDrawerChange;
        const intervAreaObjList = props.intervAreaObjList;
        const intervObjList = props.intervObjList;
        const rankedIntervMstID2DObjArray = props.rankedIntervMstID2DObjArray;
        const resultWkbkFileURLString = props.resultWkbkFileURLString;
        const showChildrenIntervBool = props.showChildrenIntervBool;
        const onShowChildrenIntervChange = props.onShowChildrenIntervChange;
        const showMaternalIntervBool = props.showMaternalIntervBool;
        const onShowMaternalIntervChange = props.onShowMaternalIntervChange;

        const resultForm = (
            <HLResultForm
                intervAreaObjList={intervAreaObjList}
                intervObjList={intervObjList}
                passData={(o) => this.setState(o)} // markRef
                rankedIntervMstID2DObjArray={rankedIntervMstID2DObjArray}
                resultWkbkFileURLString={resultWkbkFileURLString}
                showChildrenIntervBool={showChildrenIntervBool}
                onShowChildrenIntervChange={onShowChildrenIntervChange}
                showMaternalIntervBool={showMaternalIntervBool}
                onShowMaternalIntervChange={onShowMaternalIntervChange}
            />
        );

        // const downloadBtn =
        //     <GetAppIcon
        //         style = {{
        //             color         : Theme.HL_SecondaryColor,
        //             cursor        : "pointer",
        //             float         : "right",
        //             marginRight   : 10,
        //             marginTop     : 13,
        //         }}
        //         onClick = {this.onDownloadTable}
        //     />;

        // const downloadBtn =
        //     <IconButton
        //         onClick = {this.onDownloadTable}
        //         style   = {{
        //             color      : Theme.HL_SecondaryColor,
        //             cursor     : "pointer",
        //             display    : "inline-block",
        //             marginLeft : 10,
        //             padding    : 0,
        //         }}
        //     >
        //         <GetAppIcon
        //             style = {{
        //                 color : Theme.HL_SecondaryColor,
        //             }}
        //         />
        //     </IconButton>;

        const downloadBtn = (
            <TButton
                caption={"Download tables"}
                captionStyles={{
                    fontSize: 16,
                    ...Theme.labelFontStyle,
                    marginTop: 5,
                    marginBottom: 5,
                }}
                containerStyle={{
                    //display      : "inline-block",
                    float: "right",
                    fontFamily: Theme.fontFamily,
                    //marginBottom : 20,
                    //marginLeft   : Theme.leftIndent,
                    marginRight: 20,
                    //marginTop    : Theme.topIndent,
                }}
                key={"downloadBtn"}
                style={{
                    backgroundColor: Theme.HL_BtnBackgroundColor,
                    fontFamily: Theme.fontFamily,
                }}
                onClick={this.onDownloadBtnClick}
            />
        );

        const slideDrawer = (
            <TSlideDrawer
                anchor={"right"}
                content={resultForm}
                saveButton={false}
                title={"Prioritized interventions"}
                topRightComponents={downloadBtn}
                onClose={onDrawerChange}
            />
        );

        return slideDrawer;
    }
}

export default HLResultSlideDrawer;
